import * as CurrencyFormatter from "currencyformatter.js";
import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { LangLoaderUtil } from "../../util/lang/LangLoaderUtil";
/**
 * CurrencyLoader.ts
 */
export class CurrencyLoader {
    constructor() { }
    load(_callback) {
        let url = LangLoaderUtil.getLangOrigin();
        let cache = Date.now();
        url += "/rgs/lang/currency/currency.json?cache=" + cache;
        let request = new HttpRequest(RequestConstants.GET, url);
        request.setContentType(RequestConstants.APPLICATION_JSON);
        request.setResponseType(RequestConstants.TEXT);
        request.onComplete(() => {
            let currencies = request.getJSON();
            if (currencies) {
                if (currencies["symbols"]) {
                    console.log("Changing the symbols!!");
                    CurrencyFormatter.symbols = currencies["symbols"];
                }
                if (currencies["defaultLocales"]) {
                    console.log("Changing the defaultLocales!!");
                    CurrencyFormatter.defaultLocales = currencies["defaultLocales"];
                }
                if (currencies["locales"]) {
                    console.log("Changing the locales!!");
                    CurrencyFormatter.locales = currencies["locales"];
                }
            }
            _callback();
        }, this);
        request.onError(() => {
            console.error("Failed to get currencies from " + url);
            _callback();
        }, this);
        request.send();
    }
    isStaging(hostName) {
        return this.contains(hostName, ["-sta"]);
    }
    contains(hostname, patterns) {
        let valid = false;
        for (let nextPattern of patterns) {
            if (hostname.indexOf(nextPattern) >= 0) {
                valid = true;
                break;
            }
        }
        return valid;
    }
}
//# sourceMappingURL=CurrencyLoader.js.map